<template>
  <div class="left-container">
    <div class="logo-container" @click="$router.push('/home')">
      <img v-show="!isCollapse" :src="logoBig" class="logo-image" key="1" />
      <img v-show="isCollapse" :src="logoSmall" class="logo-image small" key="2 " />
    </div>
    <el-scrollbar class="menu-list">
      <el-menu :collapse="isCollapse" class="menu-container" :default-active="curPath"
        :collapse-transition="false">
        <template v-for="(menu,i) in list" :key="menu.menuId">
          <el-menu-item v-if="menu.menuCode"
          :index="menu.menuName"
          :style="{'margin-top': i===0?'12px':'0px'}"
          @click="selectMenu(menu.path)" class="sub-menu"
            :class="{ 'is-active': curPath === menu.path }">
            <div class="icon-wrapper">
              <svg class="icon el-icon-menu">
                <use :xlink:href="menu.icon"></use>
              </svg>
            </div>
            <template #title>
              <span class="menu-title strong">{{ menu.menuName }}</span>
            </template>
          </el-menu-item>
          <el-sub-menu v-else class="sub-menu" :index="menu.menuName" popper-class="custom-menu-popper">
            <template #title>
              <div class="icon-wrapper">
                <svg class="icon el-icon-menu">
                  <use :xlink:href="menu.icon"></use>
                </svg>
              </div>
              <span class="menu-title strong">{{ menu.menuName }}</span>
            </template>
            <el-menu-item v-for="sub in menu.childMenuVos" :key="sub.menuId" :index="sub.path"
              @click="selectMenu(sub.path)">
              <template #title>
                <span class="sub-name">{{ sub.menuName }}</span>
              </template>
            </el-menu-item>
          </el-sub-menu>
        </template>
      </el-menu>
    </el-scrollbar>
    <div class="footer">
      <i class="fold" :class="[isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold']" @click="toggle"></i>
    </div>
  </div>
</template>

<script>
import { ref, watch, inject } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import LogoTitle from '@teacher/assets/images/yx-title-2.png';
import LogoIcon from '@teacher/assets/images/yx-icon.png';

export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, context) {
    const curPath = ref('');
    const route = useRoute();
    // const openeds = ref([]);
    const app = inject('app');
    const store = inject('store');
    const { api } = inject('global');
    const $message = inject('$message');
    // openeds.value = props.list.map((item) => item.menuName);
    // 针对子路由跟菜单如何匹配.
    watch(
      () => route.matched,
      async (m) => {
        curPath.value = m[0]?.path;
      },
      {
        immediate: true,
      },
    );

    const router = useRouter();

    function checkedMerchant(path) {
      api
        .sfgjGetSfgjInfo()
        .then((res) => {
          if (res.code === 200) {
            if (res.data && res.data.isOpenSfgj && res.data.sfgjUrl) {
              window.open(res.data.sfgjUrl, '_black');
              setTimeout(() => {
                // eslint-disable-next-line no-undef
                gtag('event', 'x3-pc-event-page', {
                  x3_web_env: process.env.VUE_APP_x3_env,
                  x3_pc_bunisess_type: 'x3-PC-老师端',
                  x3_client_type: app.tool.getBrowserType(),
                  x3_company_name: store.user.value.companyInfoVo.companyName,
                  x3_nav_menu_name: '收费管家',
                  x3_page_alias: '校管家收费管家',
                  x3_page_path: '_blank',
                });
              }, 301);
              return true;
            }
            router.push({ path });
          }
          if (res.code > 60000) {
            $message.error(res.msg || '网络异常，请稍后重试');
            return false;
          }
          return true;
        })
        .catch((err) => {
          if (!err || !err.code) {
            console.log(err);
            $message.error(err.msg || '网络异常，请稍后重试');
          }
        });
    }
    // 路由跳转有可能被终止,所以拦截el-menu的默认动作
    function selectMenu(path) {
      if (path === '/fee-manage') {
        checkedMerchant(path);
        return false;
      }
      if (path === '/member') {
        const openProductCodeList = store.user.value?.companyInfoVo?.openProductCodeList;
        if (openProductCodeList && openProductCodeList.includes('MEMBER')) {
          const { location } = window;
          window.open(`${location.origin}/huiyuan${location.search}`, '_black');
        } else {
          router.push({ path });
        }
        setTimeout(() => {
          // eslint-disable-next-line no-undef
          gtag('event', 'x3-pc-event-page', {
            x3_web_env: process.env.VUE_APP_x3_env,
            x3_pc_bunisess_type: 'x3-PC-老师端',
            x3_client_type: app.tool.getBrowserType(),
            x3_company_name: store.user.value.companyInfoVo.companyName,
            x3_nav_menu_name: '会员积分',
            x3_page_alias: '云校-会员积分',
            x3_page_path: '_blank',
          });
        }, 301);
        return false;
      }
      router.push({ path });
      return true;
    }

    const isCollapse = ref(false);
    function toggle() {
      isCollapse.value = !isCollapse.value;
      context.emit('collapse', isCollapse.value);
    }

    const logoBig = ref(LogoTitle);
    const logoSmall = ref(LogoIcon);
    return {
      isCollapse,
      curPath,
      logoBig,
      logoSmall,
      // openeds,
      toggle,
      selectMenu,
    };
  },
};
</script>

<style lang="scss" scoped>
.left-container {
  height: 100vh;
  // display: flex;
  // justify-content: space-between;
  // flex-direction: column;

  // background: #1f2e54;
  .logo-container {
    height: 54px;
    width: 100%;
    position: relative;
    cursor: pointer;
    padding: 0 18px;
    background-color: white;
    .logo-image {
      left: 28px;
      top: 8px;
      position: absolute;
      width: 134px;

      &.small {
        left: 28px;
        top: 15px;
        width: 26px;
      }
    }
  }

  .footer {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    position: fixed;
    bottom: 0px;
    // border-top: 1px solid rgba(var(--black-rgb), 0.2);
    .fold {
      font-size: 18px;
      color: var(--g2);
      margin-left: 18px;
      cursor: pointer;
    }
  }

  .menu-list {
    padding: 0 8px;
    flex: 1 1 auto;
    overflow-y: auto;
    overflow-x: hidden;
    user-select: none;
    height: calc(100% - 95px);

    .menu-container {
      border-right: none !important;

      .icon {
        width: 27px;
        height: 27px;
        margin-right: 7px;
        flex: 0 0 auto;
      }

      .icon-wrapper {
        height: 100%;
        display: flex;
        align-items: center;
      }

      .menu-title {
        min-width: 126px;
        display: flex;
        align-items: center;
      }

      .sub-menu {
        margin: 1px 0;

        .sub-name {
          padding-left: 14px;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.menu-list {
  .el-menu {
    background: transparent;

    .menu-title {
      color: var(--g2);
      display: flex;
      align-items: center;
      height: 100%;
    }
    .strong {
      color: var(--g1);
      font-weight: bold;
    }

    .el-menu-item {
      border-radius: 8px;
      display: flex;
      align-items: center;
      margin: 4px 0;
      // height: 46px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .el-sub-menu__title:hover, .el-menu-item:hover  {
      background-color: var(--white);
      color: var(--primary);
      border-radius: 8px;

      .menu-title {
        color: var(--primary);
      }
    }

    .el-menu-item.is-active {
      background-color: var(--white);
    }
  }
}

.custom-menu-popper {
  border-radius: 16px !important;
  overflow: hidden;
}
</style>
